import { VehicleType } from '../types';
import Trip from '../Trip';
import {
    GetSeatsApiApiV2GetSeatsGet,
    type GetServicesResultBus,
} from '@clients/BusApi';

export default class Bus extends Trip {
    /**
     * Time of Bus Departure from origin in 'hh:mm' format
     */
    override departureTime = '';

    override stops = 0;

    /**
     * Time of Bus arrival to destination in 'hh:mm' format
     */
    override arrivalTime = '';

    override origin = '';

    override destination = '';

    reservable = true;

    id = 0;

    override departureDateTime: Date = new Date(0);

    override arrivalDateTime: Date = new Date(0);

    override vehicleType: VehicleType = VehicleType.Bus;

    override originCityName = '';

    override originCode = '';

    override originTerminal = '';

    override destinationCityName = '';

    override destinationCode = '';

    override destinationTerminal = '';

    isVip = false;

    originId = 0;

    destinationId = 0;

    override key = '';

    override showCityCodes = false;

    cancellationTerms: string | null = null;

    needsSelectSeat = true;

    isCar = false;

    override get serviceId(): number {
        return this.id;
    }

    override get serviceNumber(): string {
        return '';
    }

    override get destinationHasWarning() {
        return true;
    }

    constructor(bus: GetServicesResultBus | null = null) {
        super();

        if (bus === null) {
            return;
        }

        this.corporationInfo = {
            logoUrl: `/img/busCorporations/svg/${bus.superCorporationID}.svg`,
            logoFallbackUrl: `/img/busCorporations/${bus.superCorporationID}.png`,
            title: bus.superCorporation || '',
            code: bus.superCorporationID?.toString() || '',
        };

        this.carrierCode = bus.superCorporationID?.toString() ?? null;
        this.isVip = !!bus.isVIP;
        this.departureTime = getTime(bus.departureTime || '');
        this.departureDateTime = dayConfig.gregory(bus.departureTime).toDate();
        this.stops = 0;
        if (!bus.arrivalTime) {
            bus.arrivalTime = bus.departureTime;
        }
        this.arrivalTime = getTime(bus.arrivalTime || '');
        this.arrivalDateTime = dayConfig.gregory(bus.arrivalTime).toDate();
        this.origin = bus.fromName || '';
        this.destination = bus.toName || '';
        // this.cancellationTerms = bus.cancellationTerms;
        this.id = bus.id || 0;
        this.originCityName = bus.fromCity || '';
        this.originTerminal = bus.fromTerminal || 'پایانه مسافربری';
        this.destinationCityName = bus.toCity || '';
        this.destinationTerminal = bus.toTerminal || 'پایانه مسافربری';
        this.originId = bus.from || 0;
        this.destinationId = bus.to || 0;
        this.originCode = bus.from?.toString() || '';
        this.destinationCode = bus.to?.toString() || '';
        this.vehicleInfo = {
            title: bus.isCar ? 'تاکسی' : 'اتوبوس',
            type: bus.busType || '',
            code: bus.busTypeID?.toString(),
            description: bus.busType ?? undefined,
        };
        this.isCar = !!bus.isCar;
        this.needsSelectSeat = !!bus.needsSelectSeat;
        if (this.isCar) {
            this.vehicleType = VehicleType.Taxi;
            this.corporationInfo.logoUrl = '/img/busCorporations/160.png';
            this.corporationInfo.logoFallbackUrl =
                '/img/busCorporations/160.png';
        }
        this.key = bus.id?.toString() || '';
        this.tripMidStops = bus.intermediateDestinations || [];
        this.finalDestination = bus.finalDestinationCity ?? null;
    }

    async loadSeats() {
        const { data } = await GetSeatsApiApiV2GetSeatsGet({ busId: this.id });
        return data;
    }
}
